import { EditIcon, ReplaceIcon } from "assets/icons";
import { useBoolean } from "hooks";
import { t } from "i18next";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { Button, DeletedProfileInfo } from "ui";

import { useGetDriverById } from "../../apis";
import { useDriversBasePath } from "../../hooks";
import { ChangeDriverDeleteStatusModal } from "../modals";

import styles from "./DriverActionButtons.module.scss";

const DriverActionButtons = () => {
  const navigate = useNavigate();
  const basePath = useDriversBasePath();
  const { driverId } = useParams();

  const { driver } = useGetDriverById(driverId as string);

  const {
    value: isChangeDeleteStatusModalOpen,
    setTrue: openChangeDeleteStatusModal,
    setFalse: closeChangeDeleteStatusModal
  } = useBoolean(false);

  const navigateToDriverEdit = () => {
    navigate(`${basePath}/edit/${driverId}`);
  };

  const daysLeftToRestore = Math.ceil(
    moment(driver?.accountRestorationDeadline).diff(moment(), "days", true)
  );

  return driver ? (
    <>
      <div className={styles.buttons}>
        {driver.isDeleted ? (
          <>
            <DeletedProfileInfo
              deletedAt={driver.deletedAt}
              accountRestorationDeadline={driver.accountRestorationDeadline}
            />

            {daysLeftToRestore > 0 && (
              <Button
                icon={<ReplaceIcon width={24} height={24} fill="#FFFFFF" />}
                onClick={openChangeDeleteStatusModal}
              >
                {t("Restore")}
              </Button>
            )}
          </>
        ) : (
          <>
            <Button
              title={t("Edit")}
              variant="default"
              onClick={navigateToDriverEdit}
              icon={<EditIcon fill={"#090914"} width={18} height={18} />}
            />
            <Button
              title={t("Delete")}
              variant={"delete"}
              onClick={openChangeDeleteStatusModal}
            />
          </>
        )}
      </div>

      <ChangeDriverDeleteStatusModal
        id={String(driverId)}
        isOpen={isChangeDeleteStatusModalOpen}
        onClose={closeChangeDeleteStatusModal}
        action={driver.isDeleted ? "Restore" : "Delete"}
      />
    </>
  ) : null;
};

export default DriverActionButtons;
